exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".highlight-ink.highlight-ink{color:var(--medium-blue-color);font-weight:700;margin:0 5px}", "", {"version":3,"sources":["/Users/sourabhkumarbanka/dev/alienbrains_main_website/src/Components/HighlightInk/style.css"],"names":[],"mappings":"AAAA,6BACE,+BAAgC,AAChC,gBAAkB,AAClB,YAAc,CACf","file":"style.css","sourcesContent":[".highlight-ink.highlight-ink {\n  color: var(--medium-blue-color);\n  font-weight: bold;\n  margin: 0 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Components/HighlightInk/style.css
// module id = 425
// module chunks = 4 8